import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { List, X } from "@phosphor-icons/react";

export const LOGO = "https://customer-assets-4nw71qhi.emergentagent.net/job_spares-liquidate/artifacts/zqckagp5_Sparehub%20logo_horizoantal%20copy%202.webp";

const links = [
  { to: "/lots", label: "Browse Lots" },
  { to: "/sell", label: "Sell Stock" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  const dashHref = user && user.role === "admin" ? "/admin" : user && user.role === "seller" ? "/seller" : "/account";

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5">
          <img src={LOGO} alt="SparesHub" className="h-8 w-auto md:h-9" />
          <span className="hidden rounded-md bg-navy-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-subtext sm:inline-block">Bulk Liquidation</span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm font-medium transition-colors hover:text-brand ${loc.pathname.startsWith(l.to) ? "text-brand" : "text-ink"}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          {user ? (
            <>
              <Button asChild variant="ghost" className="text-ink" data-testid="nav-dashboard">
                <Link to={dashHref}>{user.role === "admin" ? "Admin" : user.role === "seller" ? "Seller" : "My Account"}</Link>
              </Button>
              <Button onClick={async () => { await logout(); nav("/"); }} variant="outline" className="border-darkteal/40 text-darkteal hover:bg-darkteal hover:text-white" data-testid="nav-logout">Log out</Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm font-medium text-ink hover:text-brand">Login</Link>
              <Button asChild variant="outline" className="border-darkteal/40 text-darkteal hover:bg-darkteal hover:text-white" data-testid="nav-list-stock">
                <Link to="/register?role=seller">List Your Stock</Link>
              </Button>
              <Button asChild className="bg-brand text-white hover:bg-brand-hover" data-testid="nav-browse">
                <Link to="/lots">Browse Lots</Link>
              </Button>
            </>
          )}
        </div>

        <button className="text-ink md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border bg-white px-5 py-4 md:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-ink">{l.label}</Link>
            ))}
            <div className="h-px bg-border" />
            {user ? (
              <>
                <Link to={dashHref} onClick={() => setOpen(false)} className="font-semibold text-ink">Dashboard</Link>
                <button onClick={async () => { await logout(); setOpen(false); nav("/"); }} className="text-left text-ink">Log out</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="text-ink">Login</Link>
                <Button asChild variant="outline" className="border-darkteal/40 text-darkteal"><Link to="/register?role=seller" onClick={() => setOpen(false)}>List Your Stock</Link></Button>
                <Button asChild className="bg-brand text-white hover:bg-brand-hover"><Link to="/lots" onClick={() => setOpen(false)}>Browse Lots</Link></Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
